import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import HomeRedirect from './HomeRedirect';

const AuthRedirect = ({ children }) => {
  const auth = useSelector(state => state.auth);
  const location = useLocation();
  const { pathname } = location;

  if (!auth.isLoading) {
    if (pathname.startsWith('/auth') && !auth.isFullyAuthenticated) return children;
    else if (!pathname.startsWith('/auth') && auth.isFullyAuthenticated) return children;
    else return <HomeRedirect />;
  }
  return children;
}
AuthRedirect.propTypes = {
  children: PropTypes.node
};
export default AuthRedirect;